import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persianFa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorianEn from "react-date-object/locales/gregorian_en";

/**
 * Formats a date string to Persian calendar format
 * @param {string} dateString - The date string to format
 * @param {string} format - The format string (default: "YYYY/MM/DD HH:mm")
 * @returns {string} - Formatted Persian date string
 */
export const formatPersianDate = (dateString, format = "YYYY/MM/DD HH:mm") => {
  if (!dateString) return 'نامشخص';
  try {
    return new DateObject({
      date: dateString,
      calendar: persian,
      locale: persianFa,
      digits: 'fa'
    }).format(format);
  } catch (error) {
    console.error('Error formatting Persian date:', error);
    return 'تاریخ نامعتبر';
  }
};

/**
 * Formats a date string to Persian calendar format with only date
 * @param {string} dateString - The date string to format
 * @returns {string} - Formatted Persian date string
 */
export const formatPersianDateOnly = (dateString) => {
  return formatPersianDate(dateString, "YYYY/MM/DD");
};

/**
 * Formats a date string to Persian calendar format with only time
 * @param {string} dateString - The date string to format
 * @returns {string} - Formatted Persian time string
 */
export const formatPersianTime = (dateString) => {
  return formatPersianDate(dateString, "HH:mm");
};

/**
 * Converts a Persian date to Gregorian date for API calls
 * @param {DateObject} persianDate - The Persian date object
 * @returns {string} - Gregorian date string
 */
export const convertPersianToGregorian = (persianDate) => {
  if (!persianDate) return null;
  try {
    return persianDate.convert(gregorian, gregorianEn).format("YYYY-MM-DDTHH:mm:ss");
  } catch (error) {
    console.error('Error converting Persian to Gregorian:', error);
    return null;
  }
};

/**
 * Creates a DateObject from a Persian date string
 * @param {string} dateString - The date string
 * @returns {DateObject} - DateObject instance
 */
export const createPersianDateObject = (dateString) => {
  if (!dateString) return null;
  try {
    return new DateObject({
      date: dateString,
      calendar: persian,
      locale: persianFa,
      digits: 'fa'
    });
  } catch (error) {
    console.error('Error creating Persian date object:', error);
    return null;
  }
};
